<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('email')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            <span align="justify">
              Correo Electrónico para Envío de Estado de Cuenta
            </span>
          </md-card-header>
          <md-card-content>  
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p> 
              <p align="justify">
                Correo electrónico *
              </p>    

              <div>            
                <md-field :class="getValidationClass('email')">
                  <md-input type="text" id="nombreparticipetitular" name="nombreparticipetitular" placeholder="Su respuesta" v-model="form.email"  autocomplete="off"/>
                  <span class="md-error" v-if="!$v.form.email.required">Esta respuesta es obligatoria.</span>
                  <span class="md-error" v-else-if="!$v.form.email.email">Formato inválido.</span>
                </md-field>

              </div>

          </md-card-content> 
        </md-card>          

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>    

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
 import { email } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item21',
  props: ["title", "data"],
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item21

    if(this.data.name=="Participe"){
      this.form.email = this.$store.state.item.item1.email
    }else{
      this.form.email = this.$store.state.item.item01.email
    }

    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        email: {required, email},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item21
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('setSaveForm', {id:"21", form: this.form, index: "30"}); 
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
